import type { FC, PropsWithChildren } from 'react';
import { Button, type ButtonProps } from '@eqi-investimentos/react';

export const PlayerButton: FC<PropsWithChildren<PlayerButtonProps>> = ({
  children,
  label,
  onClick,
  ...props
}) => (
  <Button
    variant="naked"
    className={`vp-btn ${label}`}
    data-label={label}
    onClick={onClick}
    color="content.alwaysLight"
    transition="transform 200ms"
    sx={{
      '& .chakra-icon': {
        w: '2rem',
        h: '2rem',
      },
    }}
    _hover={{
      '& .chakra-icon': { transform: 'scale(1.3)' },
    }}
    {...props}
  >
    {children}
  </Button>
);

type PlayerButtonProps = ButtonProps & {
  label?: string;
  onClick: () => void;
};
